
import './App.css';
import Company from './component/Company/Company';
import Header from './component/Header/Header';

function App() {
  
  return (
    <div className="App">
      <Header></Header>
      <Company></Company>
    </div>
  );
}

export default App;
